import React from "react";
import { useHistory } from "react-router-dom";
import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  IdentificationBadge,
  CalendarDots,
  UploadSimple,
  Check,
  PaperPlaneTilt,
} from "@phosphor-icons/react";

export const MarkTaskCompleteButton = (props) => {
  const { buttonText, startIcon, clientTaskId, clientId, markClientTaskComplete, loading, sx } =
    props;
  return (
    <LoadingButton
      onClick={() => markClientTaskComplete({ clientId, clientTaskId })}
      size="small"
      color="primary"
      startIcon={startIcon}
      loading={loading}
      aria-busy={loading}
      data-testid="mark-task-complete-button"
      sx={sx}
    >
      {buttonText}
    </LoadingButton>
  );
};

export const ResendLoginButton = (props) => {
  const { onResendLoginEmail, resendingLoginEmail, sx } = props;
  return (
    <LoadingButton
      color="secondary"
      variant="contained"
      onClick={onResendLoginEmail}
      size="small"
      startIcon={<PaperPlaneTilt />}
      loading={resendingLoginEmail}
      aria-busy={resendingLoginEmail}
      aria-label="Resend login email to client"
      data-testid="resend-login-button"
      sx={sx}
    >
      Resend Login Email
    </LoadingButton>
  );
};

export const AssignClinicianButton = (props) => {
  const { onToggleAssignClinician, sx } = props;
  return (
    <Button
      onClick={onToggleAssignClinician}
      size="small"
      startIcon={<IdentificationBadge />}
      color="primary"
      aria-label="Assign clinician to client"
      data-testid="assign-clinician-button"
      sx={sx}
    >
      Assign Clinician
    </Button>
  );
};

export const ScheduleCallButton = (props) => {
  const { sx } = props;
  const history = useHistory();
  return (
    <Button
      onClick={() => history.push("/clinician-schedule/create-event")}
      size="small"
      color="primary"
      startIcon={<CalendarDots />}
      aria-label="Schedule a call with client"
      data-testid="schedule-call-button"
      sx={sx}
    >
      Schedule Appointment
    </Button>
  );
};

export const UploadTreatmentPlanButton = (props) => {
  const { onToggleTreatmentPlanDialog, loading, sx } = props;
  return (
    <LoadingButton
      onClick={onToggleTreatmentPlanDialog}
      size="small"
      startIcon={<UploadSimple />}
      loading={loading}
      aria-busy={loading}
      aria-label="Upload treatment plan"
      data-testid="upload-treatment-plan-button"
      sx={sx}
      color="primary"
    >
      Upload Plan
    </LoadingButton>
  );
};

export const UpdateTreatmentPlanButton = (props) => {
  const { customerDetails, onOpenUpdateTreatmentPlan, loading, sx } = props;
  return (
    <LoadingButton
      onClick={() =>
        onOpenUpdateTreatmentPlan(customerDetails.treatmentPlans.find((plan) => !plan.approved))
      }
      size="small"
      startIcon={<UploadSimple />}
      loading={loading}
      aria-busy={loading}
      aria-label="Update treatment plan"
      data-testid="update-treatment-plan-button"
      sx={sx}
      color="primary"
    >
      Update Plan
    </LoadingButton>
  );
};

export const MarkAssessmentCompleteButton = (props) => {
  const { onToggleAssessmentComplete, sx } = props;
  return (
    <Button
      onClick={onToggleAssessmentComplete}
      size="small"
      startIcon={<Check />}
      color="primary"
      aria-label="Mark assessment complete"
      data-testid="mark-assessment-complete-button"
      sx={sx}
    >
      Mark Complete
    </Button>
  );
};
